module.exports = __webpack_public_path__ + "static/img/13.8297380.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/eng/13.png
// module id = RfG7
// module chunks = 0